import PropTypes from 'prop-types'
import React, { useState } from 'react'
import TriviaGame from '../components/TriviaGame'
import TriviaGameDocs from '../components/TriviaGameDocs'
import Article from '../templates/Article'

const EME6208QuizPage = props => {
  const [docsHidden, setDocsHidden] = useState(true)

  return (
    <Article pathName={props.location.pathname} pageTitle="JavaScript Quiz">
      <section aria-label="JavaScript Quiz">
        <TriviaGame
          data="mud-snail-trivia.json"
          docsHidden={docsHidden}
          max={10}
          setDocsHidden={setDocsHidden}
          title="Mud Snail Trivia"
        />
      </section>
      <TriviaGameDocs docsHidden={docsHidden} />
    </Article>
  )
}

EME6208QuizPage.propTypes = {
  location: PropTypes.object,
}

export default EME6208QuizPage
